import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import ShareIcon from '@mui/icons-material/Share';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';

import { IconButton } from 'Components/IconButton';
import { VerticalRowLeftAlign } from 'Components/Row';
import { collections, constants } from 'lib/constants';
import { useInitPlug } from 'lib/hooks';
import { nftProductState } from 'lib/recoil/selectors';
import { ReactComponent as DfinityLogo } from './dfinity-logo.svg';

export const NftProduct = () => {
	const { onBuy } = useInitPlug();

	const params = useParams();
	const nftId = params.nftId;

	const nftProduct = useRecoilValue(nftProductState(Number(nftId)));

	if (!nftProduct) {
		return <>Not found</>;
	}

	const collection = collections.find(collection => collection.id === nftProduct.collectionId);

	return (
		<Box
			sx={{
				display: 'flex',
				width: '75%',
				height: '100%'
			}}
		>
			<Paper
				sx={{
					height: 'calc(100vh - 150px)',
					minWidth: '55%',
					backgroundColor: 'action.active'
				}}
			>
				<iframe
					src={nftProduct.url}
					frameBorder='0'
					title='dada'
					loading='lazy'
					width='100%'
					height='100%'
					style={{
						borderRadius: 4
					}}
				></iframe>
			</Paper>
			<Box
				sx={{
					paddingX: constants.SPACING,
					width: '100%'
				}}
			>
				<VerticalRowLeftAlign>
					<Box>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								marginBottom: 1
							}}
						>
							<Typography variant='h4' component='h1' fontWeight='bold'>
								{nftProduct.name}
							</Typography>
							<Box>
								<IconButton
									icon={<FavoriteBorderIcon />}
									label='Add to favorites'
									color='error'
									size='large'
								/>
								<IconButton icon={<ShareIcon />} label='Share' color='primary' size='large' />
							</Box>
						</Box>
						<Typography variant='body2'>
							Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque sed lectus at nisl
							fringilla convallis.
						</Typography>
					</Box>
					{collection ? (
						<Box>
							<Typography variant='caption' fontWeight='bold'>
								Collection:
							</Typography>
							<Typography variant='subtitle2' fontWeight='bold'>
								{collection.name}
							</Typography>
						</Box>
					) : null}
					<Divider
						sx={{
							width: '100%'
						}}
					/>
					<Box>
						<Box sx={{ display: 'flex', alignItems: 'center' }}>
							<Typography variant='h6' fontWeight='bold'>
								Price: {nftProduct.price}
							</Typography>
							<Box sx={{ marginLeft: 0.5, display: 'flex', alignItems: 'center' }}>
								<DfinityLogo width={30} height={30} />
							</Box>
						</Box>
						<Button
							variant='contained'
							size='large'
							startIcon={<ShoppingCartIcon />}
							onClick={() => onBuy(nftProduct.price)}
							fullWidth={false}
							sx={{
								flexGrow: 1
							}}
						>
							Buy now
						</Button>
					</Box>
				</VerticalRowLeftAlign>
			</Box>
		</Box>
	);
};
